import { render, staticRenderFns } from "./ProductRevealCheckbox.vue?vue&type=template&id=45136b0a&scoped=true"
import script from "./ProductRevealCheckbox.vue?vue&type=script&lang=js"
export * from "./ProductRevealCheckbox.vue?vue&type=script&lang=js"
import style0 from "./ProductRevealCheckbox.vue?vue&type=style&index=0&id=45136b0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45136b0a",
  null
  
)

export default component.exports